module.exports = __webpack_public_path__ + "img/introduce-3.cec0ca8.png";